import React from 'react';
import PropTypes from 'prop-types';

import { ComponentRegistry } from 'core';

import { AutoCompleteManager } from 'apps/autocomplete/appManager';
import { OptionsManager, TreeOptionsManager } from 'apps/options/appManager';

import { CountryOption } from 'apps/payment/views/countryOption';
import { CountrySelection } from 'apps/payment/views/countrySelection';
import { BreadCrumbsSelection } from 'apps/rfq/rfqForm/views/breadCrumbsSelection';

ComponentRegistry.add('payment.countrySelection', CountrySelection);
ComponentRegistry.add('payment.countryOption', CountryOption);
ComponentRegistry.add('rfq.BreadCrumbsSelection', BreadCrumbsSelection);

export class Field extends React.Component {
  UNSAFE_componentWillMount() {
    const { fieldStore } = this.props;
    this.updateOptionsManager(fieldStore);
    if (!(fieldStore && fieldStore.draftEnabled)) return;
    window.addEventListener('storage', fieldStore.throttledHandleStorage);
    window.addEventListener('blur', fieldStore.handleBlur);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // when the formStore is instantiated after the Field is mounted, we need to
    // re-instantiate the optionsManager.
    // It would be better to tie this to the lifecycle of the FieldStore/app.
    // * This solution will leave undisposed "OptionsManagers"
    // And potentially lead to confusion over the context of Variables set/used
    this.updateOptionsManager(nextProps.fieldStore);
  }

  updateOptionsManager = fieldStore => {
    /* Since we inherit Variables from the targets manager, the form 'target' must be 
    an App or other object with a manager field. This is probably only relevant to options Managers.
    This method of getting managers through the Tree is an anti-pattern. We need to find new ways to share
    data and Variables between AppManagers! */
    this.inputId = `${fieldStore.formStore.formName}-${fieldStore.fieldName}`;
    if (fieldStore.conf.autocomplete) {
      // avoid potential loops when mounting the field more than once
      if (!fieldStore.optionsManager) {
        fieldStore.optionsManager = new AutoCompleteManager(
          fieldStore.formStore.target.manager,
          { fieldStore },
          { autoDispose: false },
        );
      }
    } else if (fieldStore.conf.options && !fieldStore.optionsManager) {
      if (!fieldStore.conf.options?.type) {
        fieldStore.optionsManager = new OptionsManager(
          fieldStore.formStore.target.manager,
          { fieldStore },
          { autoDispose: false },
        );
      } else if (fieldStore.conf.options?.type === 'treeOptions') {
        fieldStore.optionsManager = new TreeOptionsManager(
          fieldStore.formStore.target.manager,
          { fieldStore },
          { autoDispose: false },
        );
      }
    }
  };

  componentWillUnmount() {
    const { fieldStore } = this.props;
    if (!fieldStore) return;
    if (fieldStore.optionsManager) {
      fieldStore.optionsManager.dispose();
      fieldStore.optionsManager = null;
    }
    if (fieldStore && fieldStore.draftEnabled) {
      window.removeEventListener('storage', fieldStore.throttledHandleStorage);
      window.removeEventListener('blur', fieldStore.handleBlur);
    }
  }

  onFocus = e => {
    const { fieldStore } = this.props;
    if (e.target && e.target.value && e.target.value.length) {
      // Not working as expected
      // sometimes selects all input value
      // if (fieldStore.conf.suffixValue) {
      //   const { target } = e;
      //   const end = target.value.lastIndexOf(fieldStore.conf.suffixValue);
      //
      //   target.focus();
      //   target.setSelectionRange(0, end, 'forward');
      // } else {
      //
      // }

      const { length } = e.target.value;
      // NOTE: ensure that first key down gets added to end of fixedValue
      e.target.setSelectionRange(length, length);
    }
    fieldStore.SetFocus(true);
  };

  onBlur = () => {
    const { fieldStore } = this.props;
    fieldStore.SetFocus(false);
    // TODO: Figure out what the implications of removing "ignoringValidation" are...
    fieldStore.alert();
  };

  updateValue = e => {
    this.props.fieldStore.UpdateValue(e.target.value, e);
  };

  focusNext = () => {
    // no-op
  };

  focusAfterDelete = () => {
    const { fieldStore } = this.props;
    const fieldElement = document.getElementById(fieldStore.fieldName);
    if (fieldElement) fieldElement.focus();
    fieldStore.SetFocus(true);
  };
}

Field.propTypes = {
  fieldStore: PropTypes.object,
  autoFocus: PropTypes.bool,
};
